const MatColors = {
  LOW: "#44B764",
  MEDIUM: "#DC7C24",
  HIGH: "#F94444",
  "Order Request": "#F94444",
  "Re Order Request": "#F94444",
  "Order Placed": "#DC7C24",
  "Order Declined": "#595047",
  "Order Received": "#44B764",
};

export default MatColors;
